import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

interface NotificationBannerProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  message,
  isVisible,
  onClose,
  duration = 5000
}) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 animate-slide-in-left">
      <div className="bg-card border border-border rounded-lg shadow-lg p-4 pr-12 max-w-sm">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <div className="w-2 h-2 bg-destructive rounded-full mt-2"></div>
          </div>
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground">{message}</p>
          </div>
          <button
            onClick={onClose}
            className="absolute top-2 right-2 p-1 rounded-full hover:bg-muted transition-colors"
            aria-label="Close notification"
          >
            <X className="w-4 h-4 text-muted-foreground" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationBanner;